import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import Button from '~/components/isolated/Button/Button';
import Modal from '~/components/Modal/Modal';
import { useModal } from '~/hooks/useModal';

import { userStore } from '~/stores';

import styles from './ModalLogoutV3.module.scss';

const ModalLogoutV3 = () => {
  const { t } = useTranslation();
  const { closeModal } = useModal();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await userStore.logout().catch((error) => error && console.error(error));
      navigate('/');
    } catch (e) {
      console.error(e);
    }
  };

  const backHandler = () => closeModal();

  return (
    <Modal
      isShow={true}
      className={styles.modal}
      onBackdropDismiss={backHandler}
    >
      <div className={styles.content}>
        <div className={styles.title}>
          <h2 className={styles.titleText}>{t('phrases:wantToLogout')}</h2>
        </div>
        <div className={styles.buttons}>
          <Button
            variant="secondary"
            size="M"
            onClick={handleLogout}
            className={styles.button}
          >
            {t('confirm')}
          </Button>
          <Button
            variant="primary"
            size="M"
            onClick={backHandler}
            className={styles.button}
          >
            {t('cancel')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default observer(ModalLogoutV3);
